import { render, staticRenderFns } from "./manage-beneficiaries.component.vue?vue&type=template&id=7335e852&"
import script from "./manage-beneficiaries.component.vue?vue&type=script&lang=ts&"
export * from "./manage-beneficiaries.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports